module.exports = __webpack_public_path__ + "img/unicode_code_point_decomposition.dc6ed596.png";